import React from "react";
import { IRouteItem, Loadable } from "@techzyapp/ui-lib";
import {
  DYNAMIC_CAMPAIGNS_UPDATE_PATH,
  DYNAMIC_CAMPAIGNS_ADD_PATH,
  DYNAMIC_CAMPAIGNS_PATH,
  PER_TRANSACTION_PARTICIPATION_PATH,
  GOAL_REACHED_PARTICIPATION_PATH,
  STREAK_PARTICIPATION_PATH,
} from "utils/constants/paths";

const DynamicCampaigns = Loadable(React.lazy(() => import("./View")));
const DynamicCampaignsAddOrUpdate = Loadable(
  React.lazy(() => import("./View/AddOrUpdate"))
);
const PerTransactionParticipation = Loadable(
  React.lazy(() => import("./View/PerTransactionParticipation"))
);
const GoalReachedParticipation = Loadable(
  React.lazy(() => import("./View/GoalReachedParticipation"))
);
const StreakParticipation = Loadable(
  React.lazy(() => import("./View/StreakParticipation"))
);

export const DynamicCampaignsRoute: IRouteItem = {
  path: DYNAMIC_CAMPAIGNS_PATH,
  iconName: "SliderVertical1",
  element: React.createElement(DynamicCampaigns),
  name: "Dynamic Campaigns",
  accessKeys: ["SuperAdmin", "Admin"],
  children: [
    {
      name: "Add / Update",
      path: DYNAMIC_CAMPAIGNS_ADD_PATH,
      element: React.createElement(DynamicCampaignsAddOrUpdate),
      showInDrawer: false,
    },
    {
      path: DYNAMIC_CAMPAIGNS_UPDATE_PATH,
      element: React.createElement(DynamicCampaignsAddOrUpdate),
      showInDrawer: false,
    },
    {
      name: "Per Transaction Participation",
      path: `${PER_TRANSACTION_PARTICIPATION_PATH}/:id`,
      element: React.createElement(PerTransactionParticipation),
      showInDrawer: false,
    },
    {
      name: "Goal Reached Participation",
      path: `${GOAL_REACHED_PARTICIPATION_PATH}/:id`,
      element: React.createElement(GoalReachedParticipation),
      showInDrawer: false,
    },
    {
      name: "Streak Participation",
      path: `${STREAK_PARTICIPATION_PATH}/:id`,
      element: React.createElement(StreakParticipation),
      showInDrawer: false,
    },
  ],
};
